import {
  faPlus,
  faTrash,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useAppContext } from "../../../AppProvider";
import { useIndexUsersContext } from "../providers/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAllCompanies } from "../../../Components/Selects/AsyncSelect/api";
import { useTypes } from "../../../utilities/types";

export const isDisabledDelete = (selectedRows) => {
  const { accessTokenPayload } = useAppContext();

  return !selectedRows.every(
    (item) => item.ownerId === accessTokenPayload.owner
  );
};

export const useListProps = () => {
  const { dictionary } = useAppContext();
  const { timezones } = useTypes();

  const context = useIndexUsersContext();

  return {
    path: `/user-service/users`,
    banner: {
      enabled: true,
    },
    pagination: { enabled: true },
    title: dictionary.users.users,
    create: {
      enabled: true,
      action: () =>
        context?.setModalConfig({
          isOpen: true,
          action: "create",
          size: "md",
          title: `${
            dictionary.actions.add
          } ${dictionary.users.user.toLowerCase()}`,
        }),
      title: `${dictionary.actions.add} ${dictionary.users.user.toLowerCase()}`,
      icon: faPlus,
    },
    selectRowsEnabled: { enabled: true },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModalConfig({
            isOpen: true,
            size: "sm",
            title: dictionary.actions.delete_selected,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),
        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
        isDisabled: isDisabledDelete,
      },
    ],
    filters: {
      name: "users",
      preserve: false,
      list: [
        {
          fieldName: "ownerId",
          label: dictionary.registries.owner,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue, pagination) => {
            // const params: FetchParam = {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCompanies(params);
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "name",
          label: dictionary.registries.name,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "surname",
          label: dictionary.users.surname,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "email",
          label: dictionary.registries.email,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "timeZone",
          label: dictionary.locations.timezone,
          type: "select",
          options: timezones,
          primary: false,
          col: 3,
        },
      ],
    },
  };
};
